
import { boolean, object, string } from 'yup';

export const contactFormSchema = object({
  Name: string().trim().required('Name is a required field'),
  Email: string().trim().email('Please enter a valid e-mail').max(254, 'E-mail is too long').required('E-mail is a required field'),
  Message: string().trim().required('Message is a required field'),
  AGREEMENT: boolean()
    .oneOf([true], 'Agreement to the company\'s Terms & Privacy Policy is required')
    .required('Agreement to the company\'s Terms & Privacy Policy is required'),
  SUBSCRIBE: boolean().default(false),
  TYPE_FORM: string().default('contact'),
  PORTFOLIO: string().default('Noord'),
  Theme: string().default('None'),
});
